<template>
    <section class="about-services-wrapper">
        <div class="left-shape1-ser"></div>
        <div class="left-shape2-ser"></div>
        <span class="a-s-s1">Co zapewniamy</span>
        <span class="a-s-s2">Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptas ex ducimus optio!</span>
        <div class="cards">
            <ul>
                <li>
                    <v-card elevation="5" class="card mx-auto my-12">
                        <div class="card-left">
                            <span class="a-s-s3">Painting</span>
                            <span class="a-s-s4">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nam, ipsum saepe. Consectetur dolor vitae dolore neque hic harum nostrum quas atque maxime quae?</span>
                            <span class="a-s-s4">Lorem ipsum dolor, sit amet consectetur adipisicing elit. Reprehenderit, necessitatibus nobis ducimus, qui tenetur consectetur, quia earum dicta quam vitae eligendi aut in.</span>
                            <v-divider class="mx-4"></v-divider>
                            <span class="a-s-s5">Lorem ipsum dolor sit amet consectetur, adipisicing elit. Fugit obcaecati quaerat ipsum?</span>
                            <v-divider class="mx-4"></v-divider>
                            <v-card-actions style="display: flex; justify-content: space-evenly">
                                <router-link style="text-decoration:none;" :to="`/${$i18n.locale}/painting`">
                                    <v-btn large color="#10424b" outlined>
                                        Dowiedz się więcej
                                    </v-btn>
                                </router-link>
                            </v-card-actions>
                        </div>
                        <div class="card-right p"></div>
                    </v-card>
                </li>
                <li>
                    <v-card elevation="5" class="card mx-auto my-12">
                        <div class="card-left">
                            <span class="a-s-s3">Scaffolding</span>
                            <span class="a-s-s4">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nam, ipsum saepe. Consectetur dolor vitae dolore neque hic harum nostrum quas atque maxime quae?</span>
                            <span class="a-s-s4">Lorem ipsum dolor, sit amet consectetur adipisicing elit. Reprehenderit, necessitatibus nobis ducimus, qui tenetur consectetur, quia earum dicta quam vitae eligendi aut in.</span>
                            <v-divider class="mx-4"></v-divider>
                            <span class="a-s-s5">Lorem ipsum dolor sit amet consectetur, adipisicing elit. Fugit obcaecati quaerat ipsum?</span>
                            <v-divider class="mx-4"></v-divider>
                            <v-card-actions style="display: flex; justify-content: space-evenly">
                                <router-link style="text-decoration:none;" :to="`/${$i18n.locale}/scaffolding`">
                                    <v-btn large color="#10424b" outlined>
                                        Dowiedz się więcej
                                    </v-btn>
                                </router-link>
                            </v-card-actions>
                        </div>
                        <div class="card-right s"></div>
                    </v-card>
                </li>
                <li>
                    <v-card elevation="5" class="card mx-auto my-12">
                        <div class="card-left">
                            <span class="a-s-s3">Welding</span>
                            <span class="a-s-s4">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nam, ipsum saepe. Consectetur dolor vitae dolore neque hic harum nostrum quas atque maxime quae?</span>
                            <span class="a-s-s4">Lorem ipsum dolor, sit amet consectetur adipisicing elit. Reprehenderit, necessitatibus nobis ducimus, qui tenetur consectetur, quia earum dicta quam vitae eligendi aut in.</span>
                            <v-divider class="mx-4"></v-divider>
                            <span class="a-s-s5">Lorem ipsum dolor sit amet consectetur, adipisicing elit. Fugit obcaecati quaerat ipsum?</span>
                            <v-divider class="mx-4"></v-divider>
                            <v-card-actions style="display: flex; justify-content: space-evenly">
                                <router-link style="text-decoration:none;" :to="`/${$i18n.locale}/welding`">
                                    <v-btn large color="#10424b" outlined>
                                        Dowiedz się więcej
                                    </v-btn>
                                </router-link>
                            </v-card-actions>
                        </div>
                        <div class="card-right w"></div>
                    </v-card>
                </li>
            </ul>
        </div>
    </section>
</template>

<script>
export default {
    name: 'about-services'
}
</script>

<style lang="scss">
@mixin mobile {
    @media only screen and (max-width: 700px) {
        @content;
    }
}

@mixin mobileBig {
    @media only screen and (max-width: 1400px) {
        @content;
    }
}
$shape-color: #14525e;
.about-services-wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;
    background-color: #10424b;
    color: white;
    .left-shape1-ser {
        position: absolute;
        width: 150px;
        height: 1200px;
        background-color: $shape-color;
        margin: 0 0 0 20%;
        transform: skew(-20deg);
        @include mobileBig {
            width: 80px;
        }
        @include mobile {
            margin: 0 0 0 -10%;
        }
    }

    .left-shape2-ser {
        margin: 0 300px 0 35%;
        position: absolute;
        width: 150px;
        height: 1200px;
        background-color: $shape-color;
        transform: skew(-20deg);
        @include mobileBig {
            width: 80px;
        }
    }
    .a-s-s1 {
        z-index: 2;
        font-size: 46px;
        margin: 50px 0 30px 0;
    }
    .a-s-s2 {
        z-index: 2;
        font-size: 20px;
    }
    .cards {
        z-index: 2;
        padding: 50px 0 50px 0;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        width: 100%;
        padding: 0 200px;
        @include mobileBig {
            padding: 0 20px;
        }
        ul {
            display: flex;
            flex-wrap: wrap;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            width: 100%;
            margin: 0;
            padding: 0;
            height: auto;
            li {
                width: 100%;
                list-style-type: none;
                height: auto;
                .card {
                    display: flex;
                    flex-direction: row;
                    width: 100%;
                    height: auto;
                    @include mobileBig {
                        flex-direction: column;
                    }
                    .card-left {
                        display: flex;
                        flex-direction: column;
                        width: 60%;
                        padding: 20px 0 20px 0;
                        @include mobileBig {
                            width: 100%;
                            padding: 20px 0 0 0;
                        }
                        .a-s-s3 {
                            font-size: 30px;
                            padding: 10px 0 20px 0;
                            @include mobileBig {
                                font-size: 28px;
                            }
                        }
                        .a-s-s4 {
                            font-size: 22px;
                            padding: 0 30px 20px 30px;
                            text-align: left;
                            @include mobileBig {
                                text-align: center;
                                font-size: 18px;
                            }
                        }
                        .a-s-s5 {
                            font-size: 18px;
                            margin: 10px 0 10px 0;
                            @include mobileBig {
                                font-size: 16px;
                                margin: 10px;
                            }
                        }
                    }
                    .card-right {
                        width: 40%;
                        overflow: hidden;
                        background-size: cover;
                        background-position: center;
                        @include mobileBig {
                            width: 100%;
                            height: 200px;
                        }
                    }
                    .p {
                        background-image: url('../../../public/img/painting_top_section1.jpg');
                    }
                    .s {
                        background-image: url('../../../public/img/scaffolding.jpg');
                    }
                    .w {
                        background-image: url('../../../public/img/welding.jpg');
                    }
                }
            }
        }
    }
}
</style>